import React from "react";
import NavigationBar from "../../General/NavigationBar/NavigationBar";
import RentalSidebar from "../RentalSidebar/RentalSidebar";

const RentalLayout = ({ children }: { children: React.ReactNode }) => (
  <NavigationBar sidebar={<RentalSidebar />}>{children}</NavigationBar>
);

export default RentalLayout;
